module.exports = __webpack_public_path__ + "static/media/valid.14508a7b.svg";